export const stateMigrations = {
  1: (state) => {
    console.log("update auth store version 1 :");
    return {
      ...state
    };
  }
};
